(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bootstrap"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define("Paradym", ["bootstrap", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["Paradym"] = factory(require("bootstrap"), require("jQuery"));
	else
		root["Paradym"] = root["Paradym"] || {}, root["Paradym"]["pages/myweb/content/socialmediaadmin/instagramshare/mobile"] = factory(root["bootstrap"], root["jQuery"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__988__, __WEBPACK_EXTERNAL_MODULE__1145__) => {
return 